import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

interface RootProps {
  centerTextLeft: string | number;
  centerTextTop: string | number;
}

export const Root = styled("div", {
  shouldForwardProp: (prop) =>
    prop !== "centerTextLeft" && prop !== "centerTextTop",
})<RootProps>(({ centerTextLeft, centerTextTop }) => ({
  position: "absolute",
  left: centerTextLeft,
  top: centerTextTop,
  width: 100,
  textAlign: "center",
}));

export const SummaryValue = styled(Typography)(() => ({
  fontSize: "34px",
  lineHeight: "43px",
  color: "#232425",
  letterSpacing: "0.25px",
}));

export const SummaryLabel = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  lineHeight: "24px",
  color: theme.palette.gray60.main,
  letterSpacing: "0.44px",
  textTransform: "capitalize",
}));

export const SummaryType = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  lineHeight: "24px",
  color: theme.palette.gray60.main,
  letterSpacing: "0.44px",
  textTransform: "capitalize",
}));
